import ActiveUserIcon from "../../../assets/svg/active-user-icon";
import AddUserIcon from "../../../assets/svg/add-user-icon";
import AlertIcon from "../../../assets/svg/alert-icon";
import ClockIcon from "../../../assets/svg/clock-icon";
import FlaggedIcon from "../../../assets/svg/flagged-icon";
import MentionsIcon from "../../../assets/svg/mentions-icon";
import NoteIcon from "../../../assets/svg/note-icon";
import QuestionAndAnswerIcon from "../../../assets/svg/question-and-answer-icon";
import ReplyIcon from "../../../assets/svg/reply-icon";
import TasksIcon from "../../../assets/svg/tasks-icon";
import UnionIcon from "../../../assets/svg/union-icon";
import VerbachatIcon from "../../../assets/svg/verbachat-icon";
import ViewingsIcon from "../../../assets/svg/viewings-icon";
import DataSplitIcon from "../../../assets/svg/data-split-icon";
import { NotificationEventCategory } from "./types";

export const NOTIFICATION_EVENT_CATEGORY_DISPLAY = {
  [NotificationEventCategory.ACTIVITY]: "Activity",
  [NotificationEventCategory.SUPPORT]: "Support",
  [NotificationEventCategory.RESPONSE]: "Response",
  [NotificationEventCategory.TECHNICAL_ISSUES]: "Technical Issues",
  [NotificationEventCategory.ORG]: "Organization",
};

export const NOTIFICATION_EVENT_DESCRIPTION = {
  [NotificationEventCategory.TECHNICAL_ISSUES]:
    "Reports service outages such as Cloudflare or any system-level downtime.",
  [NotificationEventCategory.ACTIVITY]:
    "Covers all lead-related updates happening across the dashboard.",
  [NotificationEventCategory.SUPPORT]:
    "Alerts that require human assistance to interact with leads.",
  [NotificationEventCategory.RESPONSE]:
    "Includes unanswered queries and AI responses that couldn't be resolved.",
  [NotificationEventCategory.ORG]:
    "Shows all notifications across every organization, including Activity, Support, Response, and technical issues.",
};

export enum NOTIFICATION_EVENT_TYPE {
  NEW_LEAD = "new_lead",
  NEW_CONVERSATION = "new_conversation",
  HUMAN_INTERVENTION_REQUESTED = "human_intervention_requested",
  VIEWING_REQUESTED = "viewing_requested",
  LEAD_TASK_REMINDER = "lead_task_reminder",
  VIEWING_REMINDER = "viewing_reminder",
  LEAD_TASK_OVERDUE = "lead_task_overdue",
  AI_ERROR = "ai_error",
  CUSTOMER_SUPPORT_REQUESTED = "customer_support_requested",
  QUERY_NOT_ANSWERED = "query_not_answered",
  LEAD_ASSIGNED = "lead_assigned",
  LEAD_NOTE_CREATED = "lead_note_created",
  LEAD_RESPONSE = "lead_response",
  CAMPAIGN_LEAD_RESPONSE = "campaign_lead_response",
  ADDED_TO_WAITLIST = "added_to_waitlist",
  MENTIONED_USER = "mentioned_user",
  HELPDESK_MENTIONED_USER = "helpdesk_mentioned_user",
  STAGE_MIGRATION_COMPLETE = "stage_migration_complete",
}

export const NOTIFICATION_EVENT_ICON = {
  [NOTIFICATION_EVENT_TYPE.NEW_LEAD]: {
    icon: ActiveUserIcon,
    className:
      "w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk shrink-0",
  },
  [NOTIFICATION_EVENT_TYPE.NEW_CONVERSATION]: {
    icon: VerbachatIcon,
    className:
      "w-[18px] h-[18px] text-verba-chat dark:text-verba-chat-dk shrink-0",
  },
  [NOTIFICATION_EVENT_TYPE.HUMAN_INTERVENTION_REQUESTED]: {
    icon: UnionIcon,
    className:
      "w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk shrink-0",
  },
  [NOTIFICATION_EVENT_TYPE.VIEWING_REQUESTED]: {
    icon: ViewingsIcon,
    className:
      "w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk shrink-0",
  },
  [NOTIFICATION_EVENT_TYPE.LEAD_TASK_REMINDER]: {
    icon: TasksIcon,
    className:
      "w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk shrink-0",
  },
  [NOTIFICATION_EVENT_TYPE.VIEWING_REMINDER]: {
    icon: ViewingsIcon,
    className:
      "w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk shrink-0",
  },
  [NOTIFICATION_EVENT_TYPE.LEAD_TASK_OVERDUE]: {
    icon: FlaggedIcon,
    className:
      "w-[18px] h-[18px] text-verba-red-alert dark:text-verba-red-alert-dk shrink-0",
  },
  [NOTIFICATION_EVENT_TYPE.AI_ERROR]: {
    icon: AlertIcon,
    className:
      "w-[18px] h-[18px] text-lead-stage-engaged dark:text-lead-stage-engaged-dk shrink-0",
  },
  [NOTIFICATION_EVENT_TYPE.CUSTOMER_SUPPORT_REQUESTED]: {
    icon: UnionIcon,
    className:
      "w-[18px] h-[18px] text-lead-stage-engaged dark:text-lead-stage-engaged-dk shrink-0",
  },
  [NOTIFICATION_EVENT_TYPE.QUERY_NOT_ANSWERED]: {
    icon: QuestionAndAnswerIcon,
    className:
      "w-[18px] h-[18px] text-lead-stage-engaged dark:text-lead-stage-engaged-dk shrink-0",
  },

  [NOTIFICATION_EVENT_TYPE.LEAD_ASSIGNED]: {
    icon: AddUserIcon,
    className:
      "w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk shrink-0",
  },
  [NOTIFICATION_EVENT_TYPE.LEAD_NOTE_CREATED]: {
    icon: NoteIcon,
    className:
      "w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk shrink-0",
  },
  [NOTIFICATION_EVENT_TYPE.LEAD_RESPONSE]: {
    icon: ReplyIcon,
    className:
      "w-[18px] h-[18px] text-lead-stage-engaged dark:text-lead-stage-engaged-dk shrink-0",
  },
  [NOTIFICATION_EVENT_TYPE.CAMPAIGN_LEAD_RESPONSE]: {
    icon: ReplyIcon,
    className:
      "w-[18px] h-[18px] text-lead-stage-engaged dark:text-lead-stage-engaged-dk shrink-0",
  },
  [NOTIFICATION_EVENT_TYPE.ADDED_TO_WAITLIST]: {
    icon: ClockIcon,
    className:
      "w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk shrink-0",
  },
  [NOTIFICATION_EVENT_TYPE.MENTIONED_USER]: {
    icon: MentionsIcon,
    className:
      "w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk shrink-0",
  },
  [NOTIFICATION_EVENT_TYPE.HELPDESK_MENTIONED_USER]: {
    icon: MentionsIcon,
    className:
      "w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk shrink-0",
  },
  [NOTIFICATION_EVENT_TYPE.STAGE_MIGRATION_COMPLETE]: {
    icon: DataSplitIcon,
    className:
      "w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk shrink-0",
  },
};

export const NOTIFICATION_SOUND_ON_EVENT_TYPE = ["request"];

export const NOTIFICATION_REDIRECTION_PATH = {
  crm: "/dashboard/crm",
  communications: "/dashboard/communications/inbox",
  campaign_communications: "/dashboard/campaigns",
};
